import dom from "../../../../dist/jsx-render/dom"
import { SizerMode } from "./SizerMode";
import { WidgetBase } from "../Widgets/WidgetBase";

export class SizerData {
    public element: HTMLElement;
    public mode: SizerMode;
    public column: number;
    public row: number;
    public colSpan: number;
    public rowSpan: number;
    public widthAdjust: number;
    public heightAdjust: number;
    public cellWidth: number;
    public cellHeight: number;
    public parentTop: number;
    public parentLeft: number;

    constructor(widget: WidgetBase, mode: SizerMode) {
        this.mode = mode;
        this.column = widget.column;
        this.row = widget.row;
        this.colSpan = widget.colSpan;
        this.rowSpan = widget.rowSpan;
    }

    public createElement(rect: DOMRect): HTMLElement {
        this.element = <div className="sizer-box" > </div>;
        this.element.style.top = (rect.top - this.parentTop) + "px";
        this.element.style.left = (rect.left - this.parentLeft) + "px";
        this.element.style.width = rect.width + "px";
        this.element.style.height = rect.height + "px";
        return this.element;
    }

    public resize() {
        this.element.style.left = ((this.column - 1) * this.cellWidth) + (this.widthAdjust / 2) + "px";
        this.element.style.top = ((this.row - 1) * this.cellHeight) + (this.heightAdjust / 2) + "px";
        this.element.style.width = ((this.colSpan * this.cellWidth) - this.widthAdjust) + "px";
        this.element.style.height = ((this.rowSpan * this.cellHeight) - this.heightAdjust) + "px";
    }
}